import { FC, useCallback } from "react";
import ToggleField from "@/components/ToggleField";
import { SearchQueryParameterController } from "@/hooks/useSearchQueryParameter";
import { ProductSearchQueryParameter } from "@/types/ProductSearchQueryParameter";
import useDevice from "@/hooks/useDevice";

interface Props {
  checked: boolean;
  queryController: SearchQueryParameterController<ProductSearchQueryParameter>;
}

const ApplyableSampleToggle: FC<Props> = ({
  checked,
  queryController,
}): JSX.Element => {
  const { isPc } = useDevice();

  const changeHandler = useCallback(
    (e) => {
      queryController.addQuery("in_stock", e.target.checked ? "1" : undefined);
      queryController.submitQuery();
    },
    [queryController],
  );

  return (
    <ToggleField
      id={"in_stock"}
      defaultChecked={checked}
      onChange={changeHandler}
      label={
        <span className="laptop:text-sm text-xs">
          {isPc ? "サンプル請求可能製品のみ表示" : "サンプル請求可"}
        </span>
      }
    />
  );
};
export default ApplyableSampleToggle;
